export * from './get-session'
export * from './rehydrate-session'
export * from './revoke-session'
export * from './validate-session'

export const vcBaseUrl = import.meta.env.VITE_VIRTUAL_CARD_BASE_URL